export default "__VITE_ASSET__BAmEyd0Q__"